// Common actions
export const UPDATE_TEAM_FILTER = "UPDATE_TEAM_FILTER";
export const UPDATE_IS_GIVING_FEEDBACK_ERROR =
  "UPDATE_IS_GIVING_FEEDBACK_ERROR";

// Filter actions
export const UPDATE_SEARCH_TEXT = "UPDATE_SEARCH_TEXT";
export const UPDATE_APPLIED_FILTERS = "UPDATE_APPLIED_FILTERS";
export const UPDATE_FILTER_KEYS = "UPDATE_FILTER_KEYS";
export const UPDATE_GROUP_BY = "UPDATE_GROUP_BY";
export const UPDATE_PAGINATION = "UPDATE_PAGINATION";

// Flag actions
export const UPDATE_STATS_IS_DATA_LOADED = "UPDATE_STATS_IS_DATA_LOADED";
export const UPDATE_STATS_IS_LOADING = "UPDATE_STATS_IS_LOADING";
export const UPDATE_STATS_IS_BACKGROUND_LOADING =
  "UPDATE_STATS_IS_BACKGROUND_LOADING";

export const UPDATE_TABLE_IS_DATA_LOADED = "UPDATE_TABLE_IS_DATA_LOADED";
export const UPDATE_TABLE_IS_LOADING = "UPDATE_TABLE_IS_LOADING";
export const UPDATE_TABLE_IS_BACKGROUND_LOADING =
  "UPDATE_TABLE_IS_BACKGROUND_LOADING";

// Stats data actions
export const UPDATE_STATS_DATA = "UPDATE_STATS_DATA";
export const UPDATE_STATS_RAW_DATA = "UPDATE_STATS_RAW_DATA";

// Table data actions
export const UPDATE_TABLE_DATA = "UPDATE_TABLE_DATA";
export const UPDATE_TABLE_COLUMNS = "UPDATE_TABLE_COLUMNS";
export const UPDATE_TABLE_RAW_DATA = "UPDATE_TABLE_RAW_DATA";

// Reset actions
export const RESET_GIVING_FEEDBACK_DATA = "RESET_GIVING_FEEDBACK_DATA";
export const RESET_STATS_DATA = "RESET_STATS_DATA";
export const RESET_TABLE_DATA = "RESET_TABLE_DATA";
